import Vue from 'vue';
import store from './store/index'

import App from './components/imageVideoGallery.vue';

const id = '#image-video-gallery';
const container = document.querySelector(id);

if (container) {
    new Vue({
        name: 'ImageVideoGallery',
        el: id,
        render: h => h(App),
        store,
    });
}